import { DocumentsClient } from "../../../../../../../../Wrap/Api/Documents/Documents";
import { ProspectDocumentsClient } from "../../../../../../../../Wrap/Api/Documents/ProspectDocuments";
import { ServiceValidationError } from "../../../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { DocumentsLibrary } from "../../../../../../../../Wrap/Models/Domains/Documents/DocumentsLibrary";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";

export class DocumentAction {
    public static get(
        hierarchyId: string[],
        fromDate: IJsonDate,
        toDate: IJsonDate,
        searchQuery: string,
        minRow: number,
        maxRow: number,
        taskRequestIds: Array<number>,
        callback?: (val: DocumentsLibrary) => void
    ): void {
        const client = new DocumentsClient();
        const promise = client.get(hierarchyId, fromDate, toDate, searchQuery, minRow, maxRow, taskRequestIds);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {});
    }

    public static put(
        hierarchyId: string,
        documentId: number,
        status: string,
        callback?: (val: ServiceValidationError[]) => void
    ): void {
        const client = new DocumentsClient();
        const promise = client.put(documentId, hierarchyId, status);
        promise.onSuccess((result: ServiceValidationError[]) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {});
    }

    public static getProspectDocuments(
        actorId: number,
        fromDate: IJsonDate,
        toDate: IJsonDate,
        minRow: number,
        maxRow: number,
        callback?: (val: DocumentsLibrary) => void
    ): void {
        const client = new ProspectDocumentsClient();
        const promise = client.get(actorId, fromDate, toDate, minRow, maxRow);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {});
    }
}
